import {Injectable} from "@angular/core";

import {ClientConfiguration} from "../configuration/client.config";
import {CssSentence, CssWord, ContentCssClass} from "../../content/content-view.objects";
import {IReadingMode} from "../../reading/reading.component";
import {ContentCursor, AllowedSelectionType} from "../content/content.cursor";
import {ACTIVITY_STATUS, ActivityEvent, ActivityEventData} from "../../event/ActivityEvent";
import {TimerStrategy} from "../configuration/timer.config";
import {SessionService} from "../configuration/session.service";
import {EventBus} from "../../event/EventBus";
import {AudioQueueEvent, InterruptAudio} from "../../event/AudioQueueEvent";
import {AudioQueueItem, TranslateAudio} from "../audio-playback/audioqueue.item";
import {AudioQueueService} from "../audio-playback/audioqueue.service";
import {Login} from "../../login/login";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";
import {ModalConfig} from "../notification/modal.config";

export interface IReadingBookSessionData {
    "durationSessionList":[{
        "activityType":string,
        "duration": {"durationTime":number}
    }];
}

@Injectable()
export class ReadToMeService implements IReadingMode {

    constructor(private audioQueueService:AudioQueueService,
                private config:ClientConfiguration,
                private contentCursor:ContentCursor,
                private eventBus: EventBus,
                private sessionService: SessionService,
                private login: Login,
                private log: BugsnagLoggingService,
                private modalConfig: ModalConfig) {
    }

    public sentenceFinishedCallback:Function;
    public startDuration: Date;
    public endDuration: Date;

    private currentType: string;

    public startWord(wordItem:CssWord, callback?:Function):void {
    }

    public startSentence(sentenceItem:CssSentence, callback:Function):void {
        let mp3Path:string = this.config.audioUrl + sentenceItem.audio;
        this.eventBus.next(new AudioQueueEvent(
            [new AudioQueueItem(mp3Path, TranslateAudio.NO, callback)], InterruptAudio.YES));
    }

    public activate(isPipeline: boolean):void {
        this.contentCursor.setMode(ContentCssClass.MODE_READ_TO_ME);
        this.eventBus.next(
            new ActivityEvent(ACTIVITY_STATUS.activity_start, new ActivityEventData({timing: TimerStrategy.readRecord}))
        );
    }

    public startReadingActivity(type: string): void {
        this.eventBus.startActivityEvent(new ActivityEventData({timing: TimerStrategy.readRecord}));
        this.startDuration = new Date();
        this.currentType = type;
    }

    public endReadingActivity(): void {
        this.eventBus.endActivityEvent(new ActivityEventData({timing: TimerStrategy.readRecord}));
        if (this.startDuration) {
            this.endDuration = new Date();
            this.sessionService.sendBookSessionData(this.createUploadData(), () => {
                this.log.log("successful upload of reading data");
                this.startDuration = undefined;
            }, () => {
                this.modalConfig.openMessageModal("upload_error");
                this.log.log("Failed to upload reading data");
            }).subscribe((s) => {
                this.log.log("upload event: " + s);
            });
        }
    }

    public createUploadData(): IReadingBookSessionData {
        return {
            "durationSessionList":[{
                "activityType": this.currentType,
                "duration": {
                    "durationTime": this.endDuration.getTime() - this.startDuration.getTime()
                }
            }]
        };
    }

    public pause():void {
        this.audioQueueService.hardReset();
    }

    public get changeUIWhenActive():boolean {
        return false;
    }

    public get allowedSelectionType(): AllowedSelectionType {
        return AllowedSelectionType.SENTENCE;
    }

}
